import ROUTE_NAMES from '@/app/admin/router/router-const'
export default [
  {
    path: 'candidates',
    component: () => import('../CandidatesPage.vue'),
    meta: {
      perm: 'csss'
    },
    children: [
      {
        path: '',
        redirect: {name: ROUTE_NAMES.CANDIDATES_TASKS}
      },
      {
        path: 'all',
        name: ROUTE_NAMES.CANDIDATES_ALL,
        component: () => import('../CandidatesAllPage.vue')
      },
      {
        path: 'tasks',
        name: ROUTE_NAMES.CANDIDATES_TASKS,
        component: () => import('../CandidatesTasksPage.vue'),
      },
      {
        path: 'wait',
        name: ROUTE_NAMES.CANDIDATES_WAIT,
        component: () => import('../CandidatesWaitPage.vue')
      },
      {
        path: 'reserve_exchange',
        name: ROUTE_NAMES.CANDIDATES_RESERVE_EXCHANGE,
        component: () => import('../CandidatesReservePage.vue')
      },
      {
        path: 'reserved_exchanged',
        name: ROUTE_NAMES.CANDIDATES_RESERVED_EXCHANGED,
        component: () => import('../CandidatesReservedExchangedPage.vue')
      },
      {
        path: 'processed',
        name: ROUTE_NAMES.CANDIDATES_PROCESSED,
        component: () => import('../CandidatesProcessedPage.vue')
      },
    ]
  },
  
]